import React, { useState } from "react";
import "../styles/components.scss";

const InputComponent = ({ label, value, onChange, name, type }) => {
  const [isFocused, setIsFocused] = useState(false);

  const shouldFloat = isFocused || value;

  return (
    <div
      className={`roi--floating-input-container ${
        shouldFloat ? "focused" : ""
      }`}
    >
      <label
        className={`roi--floating-label ${shouldFloat ? "roi--float" : ""}`}
        htmlFor={name}
      >
        {label}
      </label>
      <input
        id={name}
        name={name}
        type={type}
        className="roi--floating-input"
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        onChange={onChange}
        value={value}
        autoComplete="off"
      />
    </div>
  );
};

export default InputComponent;
